import { createStyles } from 'antd-style';

import { ThemeFont } from '../../../../theme';
import lineIcon from '../../../../resources/img/Line.svg';

export const useWaypointLineStyles = createStyles(({ token }) => ({
  waypointLineWrapper: {
    position: 'absolute',
    bottom: 0,
    top: 0,
    width: 65,
    transform: 'translateX(100%)',
    right: 0,
  },
  waypointIcon: {
    color: token.colorPrimary,
    position: 'absolute',
    transform: 'translateX(-50%)',
    left: '50%',
    fontSize: ThemeFont.FONT_SIZE_20,
  },
  waypointIconBottom: {
    bottom: -32,
  },
  waypointIconTop: {
    top: token.marginXXS,
  },
  waypointLine: {
    backgroundImage: `url('${lineIcon}')`,
    backgroundRepeat: 'no-repeat',
    bottom: -10,
    left: '50%',
    position: 'absolute',
    top: 24,
    transform: 'translateX(-50%)',
    width: 2,
  },
  waypointBadge: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: token.colorWhite,
    border: `1px solid ${token.colorPrimary}`,
    padding: token.paddingXS,
    width: 45,
    textAlign: 'center',
    borderRadius: token.borderRadiusSM,
    lineHeight: 'normal',
    color: token.colorPrimary,
    fontWeight: 700,
  },
}));
